import React from "react";
import ResellerPortalLayout from "../Common/Layout/Layout";
import { connect } from "react-redux";
import auth from "../../../services/authService";
import { Redirect } from "react-router-dom";

const AdminPortalPage = props => {
  const PageComponent = props.component;

  if (auth.isAuthorized(props)) {
    if (props.user && props.user.user_type === "Reseller User") {   
			localStorage.removeItem("tenantTrial");
      return (
        <ResellerPortalLayout {...props}>
          <PageComponent {...props} />
        </ResellerPortalLayout>
      );
    } else {
      return <Redirect to={process.env.PUBLIC_URL + "/404"} />;
    }
  }
  return <Redirect to="/reseller/login" />;
};

const mapStateToProps = state => {
  return {
    user: state.user.user
  };
};

export default connect(mapStateToProps, null)(AdminPortalPage);
